export enum GemColor {
  Blue = 'Blue',
  Green = 'Green',
  Red = 'Red',
  Teal = 'Teal',
  Pink = 'Pink',
  BiColor = 'Bi-Color',
  MultiColor = 'Multi-Color',
  Purple = 'Purple',
  Yellow = 'Yellow',
  Violet = 'Violet',
  Brown = 'Brown',
  Orange = 'Orange',
  Grey = 'Grey',
  White = 'White',
  Black = 'Black',
  Other = 'Other',
  Nil = 'Nil',
}
